export default (that) => [
  {
    text: () => that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: () => that.$l('menu_text_edit') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
  },
  {
    text: () => that.$l('menu_text_fullMember') || '转正式产品',
    icon: 'el-icon-check',
    menuType: 'approved',
    divided: true,
    allow: 'A',
  },
  {
    text: () => that.$l('btn_return_application') || '退回申请',
    icon: 'el-icon-refresh-left',
    menuType: 'return',
    divided: true,
    allow: 'R',
  },
]
